import { usePartVehicleApplicationsFree } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.hooks';
import { PartVehicleApplicationFree } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.types';
import { getTableScrollX } from '@/utils/table';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

const ApplicationsFreeList = () => {
  const intl = useIntl().formatMessage;
  const { partId } = useRouteMatch<{ partId: string }>().params;

  const { data, isLoading } = usePartVehicleApplicationsFree(+partId);

  const columns: ColumnsType<PartVehicleApplicationFree> = [
    {
      dataIndex: 'description',
      title: 'Descrição',
      ellipsis: true,
      width: 220,
    },
    {
      dataIndex: 'fromYear',
      title: intl({
        id: 'parts.application.modal.form.fromYear',
      }),
      ellipsis: true,
      width: 220,
    },
    {
      dataIndex: 'toYear',
      title: intl({ id: 'parts.application.modal.form.toYear' }),
      ellipsis: true,
      width: 140,
    },
  ];

  return (
    <Table
      loading={isLoading}
      pagination={false}
      dataSource={data?.data}
      columns={columns}
      scroll={{ x: getTableScrollX(columns) }}
    />
  );
};

export default ApplicationsFreeList;
